import { FormControl, InputLabel, ListItemIcon, MenuItem, Select, Typography, Box, CircularProgress } from "@mui/material";
import React, { useState, useEffect } from "react";
import btcImage from "../assets/images/btc.png";
import ethImage from "../assets/images/eth.png";
import usdtethImage from "../assets/images/usdt-erc20.png";
import usdcethImage from "../assets/images/usdc-erc20.png";
import trxImage from "../assets/images/trx.png";
import ltcImage from "../assets/images/ltc.png";
import xrpImage from "../assets/images/xrp.png";
import dogeImage from "../assets/images/doge.png";
import { CryptoCurrencies } from "../enums/CryptoCurrenciesCombo.js";
import { getAgentCryptoCurrencies } from "../actions/agent.js";
import { Networks } from "../enums/networks.js";

const ComboCryptoCoins = ({ setCryptoCurrency, cryptoCurrency, setNetwork, token, setAmount }) => {
	const [cryptoCurrencies, setCryptoCurrencies] = useState(null);
	var added = [];

	const handleChange = (e) => {
		setCryptoCurrency(e.target.value);
		setAmount(null);
		setNetwork(null);
	};

	useEffect(() => {
		getAgentCryptoCurrencies(token, (data) => {
			if (!data.error) {
				setCryptoCurrencies(data.data);
			}
		});
	}, []);

	const getImageByCryptoNetwork = (cryptoCurrency, network) => {
		switch (cryptoCurrency) {
			case CryptoCurrencies.BITCOIN:
				return btcImage;
			case CryptoCurrencies.ETHEREUM:
				return ethImage;
			case CryptoCurrencies.USDT:
				if (network === Networks.ETHEREUM) {
					return usdtethImage;
				} else {
					return usdtethImage;
				}
			case CryptoCurrencies.USDC:
				if (network === Networks.ETHEREUM) {
					return usdcethImage;
				} else {
					return usdcethImage;
				}
			case CryptoCurrencies.TRX:
				return trxImage;
			case CryptoCurrencies.DOGECOIN:
				return dogeImage;
			case CryptoCurrencies.LITECOIN:
				return ltcImage;
			case CryptoCurrencies.XRP:
				return xrpImage;
			default:
				return null;
		}
	};

	return (
		<>
			{cryptoCurrencies ? (
				<FormControl sx={{ width: "100%", alignItems: "center", display: "flex" }} fullWidth>
					<Box sx={{ width: "100%", textAlign: "left", marginTop: 2, marginBottom: 1 }}>
						<Typography component="h2" variant="subtitle2" gutterBottom>
							Select Coin
						</Typography>
					</Box>
					<Select
						size="medium"
						value={cryptoCurrency ?? "first"}
						onChange={handleChange}
						sx={{ borderRadius: 6, display: "flex" }}
						fullWidth
					>
						<MenuItem value={"first"} key={-1} component="div" style={{ display: "flex" }} disabled>
							<Box sx={{ display: "flex" }}>
								<Typography sx={{ fontSize: "18px", color: "#CCCCCC" }} component="div">
									{"Select Coin"}
								</Typography>
							</Box>
						</MenuItem>
						{cryptoCurrencies.map((crypto) => {
							if (!added.includes(crypto.cryptoCurrency)) {
								added.push(crypto.cryptoCurrency);
								return (
									<MenuItem
										value={crypto.cryptoCurrency}
										selected
										key={crypto.cryptoCurrency + crypto.network}
										component="div"
										style={{ display: "flex" }}
									>
										<Box sx={{ display: "flex" }}>
											<ListItemIcon>
												<img src={getImageByCryptoNetwork(crypto.cryptoCurrency, crypto.network)} height={24} width={24} />
											</ListItemIcon>
											<Typography sx={{ fontSize: "18px", marginLeft: 2 }} component="div">
												{crypto.cryptoCurrency}
											</Typography>
										</Box>
									</MenuItem>
								);
							}
						})}
					</Select>
				</FormControl>
			) : (
				<CircularProgress color="primary" size={25} thickness={5} />
			)}
		</>
	);
};

export default ComboCryptoCoins;
